import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { ListingProvider } from '@/context/listing';

// components
import Filters from '@/braun/components/organisms/Filters';

export default () => {
  i18n.loadNamespaces('listing', () => {
    const el = document.getElementById('js-bra-filters-wrapper');
    const FiltersApp = () => (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <ListingProvider>
            <Filters {...el.dataset} />
          </ListingProvider>
        </Suspense>
      </I18nextProvider>
    );
    ReactDOM.render(<FiltersApp />, el);
  });
};
